import { watchValues } from '@dbk-legacy/muster/utils';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
/**
 * creates a keyed collection of list elements
 *
 * @param {string} sourcePath the path to original list
 * @param {string} key the key to find items by
 * @return {function} the get handler
 */
export default function byKey(sourcePath, key) {
  return (requests, { get }) =>
    (watchValues(get(`${sourcePath}.length`))
      .switchMap(([length]) => {
        if (length < 1) return Observable.of(requests.map(({ res }) => res.notFound()));
        return watchValues(get(`${sourcePath}[0..${length - 1}].${key}`))
          .map(keyValues =>
            requests.map(({ req, res }) => {
              const index = keyValues.findIndex(value => value === req.params[key]);
              if (index < 0) return res.notFound();
              return res.redirect(`${sourcePath}[${index}].${req.params['*']}`);
            })
          );
      }));
}
